export default __webpack_public_path__ + "static/land_touristic-1e60bc378ff5be257730bd60232d1123.png";